export const removeSpace = (name: string): string => {
  return name?.trim()?.replace(/\s+/g, '-')?.toLowerCase() || '';
};

export const normalizeString = (str: string) => {
  return str?.replace(/-/g, ' ').replace(/&/g, ' & ').toLowerCase();
};
